const tabs = new Set(['Wallet', 'Earn HAT', 'Campaigns', 'Publishing', 'Partners']);
export function safeOwnerDestination(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/';
  const u = new URL(value, 'https://app.hireaigo.com');
  if (u.origin !== 'https://app.hireaigo.com') return '/';
  if (u.pathname === '/growth') {
    const tab = u.searchParams.get('tab');
    const parts=[];if(tabs.has(tab))parts.push('tab='+encodeURIComponent(tab));
    const ref=u.searchParams.get('ref');if(/^[a-f0-9]{32}$/.test(ref||'')){if(!tabs.has(tab))parts.push('tab=Earn%20HAT');parts.push('ref='+ref);}
    return '/growth'+(parts.length?'?'+parts.join('&'):'');
  }
  return ['/', '/business', '/employee', '/billing', '/settings'].includes(u.pathname) ? u.pathname : '/';
}
export function loginDestination(path) { return '/login?next=' + encodeURIComponent(safeOwnerDestination(path)); }
